import { MoreVertical } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { getSessionUser } from "@/lib/eisStore";

const ITEMS = [
  { key: "attendance", label: "Attendance", color: "#FACC15", path: "/attendance" }, // yellow
  { key: "fees", label: "Fees", color: "#EC4899", path: "/fees" }, // pink
  { key: "circulars", label: "Circulars", color: "#22C55E", path: "/circulars" }, // green
  { key: "result", label: "Result", color: "#EF4444", path: "/result" }, // red
];

const TEACHER_ITEMS = [
  { key: "dashboard", label: "Dashboard", color: "#4F46E5", path: "/dashboard" },
  { key: "attendance", label: "Attendance", color: "#FACC15", path: "/attendance" },
  { key: "result", label: "Result", color: "#EF4444", path: "/result" },
  { key: "timetable", label: "Timetable", color: "#22C55E", path: "/timetable" },
];

const ADMIN_ITEMS = [
  { key: "dashboard", label: "Dashboard", color: "#4F46E5", path: "/dashboard" },
  { key: "profile", label: "Profile", color: "#22C55E", path: "/profile" },
  { key: "notifications", label: "Notifications", color: "#F59E0B", path: "/notifications" },
  { key: "circulars", label: "Circulars", color: "#EF4444", path: "/circulars" },
  { key: "student-data", label: "Student Data", color: "#0EA5E9", path: "/student-data" },
];

const MANAGEMENT_ITEMS = [
  { key: "dashboard", label: "Dashboard", color: "#4F46E5", path: "/dashboard" },
  { key: "profile", label: "Profile", color: "#22C55E", path: "/profile" },
  { key: "notifications", label: "Notifications", color: "#F59E0B", path: "/notifications" },
  { key: "circulars", label: "Circulars", color: "#EF4444", path: "/circulars" },
  { key: "fees", label: "Fees", color: "#EC4899", path: "/fees" },
];

export default function NavBar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getSessionUser();
  const items =
    user?.role === "teacher"
      ? TEACHER_ITEMS
      : user?.role === "admin"
        ? ADMIN_ITEMS
        : user?.role === "management"
          ? MANAGEMENT_ITEMS
        : ITEMS;

  return (
    <nav
      data-testid="main-navbar"
      className="w-full bg-white border-b border-slate-200 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-3 md:px-6 py-3 flex items-center gap-3 overflow-x-auto">
        {/* Sidebar trigger */}
        <button
          data-testid="sidebar-trigger"
          onClick={onOpenSidebar}
          className="nav-btn flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-xl text-white"
          style={{ backgroundColor: "#4F46E5" }} // indigo
          aria-label="Open sidebar"
        >
          <MoreVertical size={22} />
        </button>

        {/* Colored buttons - equal width, filling remaining horizontal space */}
        <div
          className={`grid gap-3 flex-1 ${
            user?.role === "admin"
              ? "grid-cols-5"
              : user?.role === "management"
                ? "grid-cols-5"
                : user?.role === "teacher"
                  ? "grid-cols-4"
                  : "grid-cols-4"
          }`}
        >
          {items.map((item) => {
            const active = location.pathname === item.path;
            return (
              <button
                key={item.key}
                data-testid={`nav-${item.key}-btn`}
                onClick={() => navigate(item.path)}
                className={`nav-btn w-full h-12 rounded-xl text-white font-semibold text-sm md:text-base whitespace-nowrap ${
                  active ? "ring-2 ring-offset-2 ring-slate-900" : ""
                }`}
                style={{ backgroundColor: item.color }}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
